<ng-container *sbPageAction>
  <ng-container *ngIf="isSplitButtonVisible()">
    <sb-view-setting [itemName]="itemName" [currentViewSetting]="viewSettingObjectFromUserSetting()"></sb-view-setting>
  </ng-container>
</ng-container>


<ng-template #tableHeader>
  <div class="d-flex align-items-center">
    <sb-boolean-toggles (toggleChange)="boolChange.emit({id: $event?.id, value: $event?.value })" *ngIf="boolToggles"
                        [toggles]="boolToggles" [viewMode]="booleanToggleViewMode"
                        class="mr-1">
      {{ 'lang.globals.statusFilter' | translate }}
    </sb-boolean-toggles>
    <ng-content select="[header-more]"></ng-content>
  </div>
</ng-template>

<ng-template #cardHeaderTemplate>
  <sb-search-bar (exactMatchChange)="exactMatchChange('exactMatch', $event)" (searchAction)="doSearch($event)"
                 *ngIf="!hideSearch"
                 [startSearch]="startSearch"
                 [(exactMatch)]="options.exactMatch"
                 [headline]="headline ? headline : 'Element'" [searchStr]="options.search"
                 [showExactMatch]="showExactMatch" [subline]="!hidePagination? paginationString: ''"
                 placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                 searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                 stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"></sb-search-bar>
  <ng-container *ngIf="hideSearch">
    <h3>{{ headline ? headline : 'Element' }}</h3>
    <small *ngIf="!hidePagination">{{ paginationString }}</small>
  </ng-container>
</ng-template>

@let isCardDisplay = isCardDisplayed();
@if (!isCardDisplay) {
  <div class="row">
    <div class="col-12">
      <sb-card [loadingDelay]="1" [loading]="loading" [classes]="isInModalContext ? 'noShadow p-0' : ''">
        <div card-header *ngIf="!hideHeadline" classes="no-border d-inline-block d-sm-flex {{headerClasses ? headerClasses : ''}}">
          <ng-template [ngTemplateOutlet]="cardHeaderTemplate"></ng-template>
        </div>
        <div card-header-more *ngIf="!hideHeadline" classes="justify-content-end py-3 py-sm-0">
          <ng-template [ngTemplateOutlet]="tableHeader"></ng-template>
        </div>
        <div card-fit>
          <ng-container *ngIf="additionalInputTop">
            <ng-template [ngTemplateOutlet]="additionalInputTop"></ng-template>
          </ng-container>
          <ng-container *ngIf="thead && tbody">
            <div
              class="tw-overflow-x-auto"
            >
              <table class="table table-hover">
                <thead>
                <ng-template [ngTemplateOutlet]="thead"></ng-template>
                </thead>
                <tbody>
                <ng-container *ngIf="singleRow">
                  <ng-template [ngTemplateOutlet]="singleRow"></ng-template>
                </ng-container>
                <ng-container *ngIf="iterateTableRows">
                  <ng-container *ngFor="let item of itemsData; let i = index">
                    <ng-template [ngForOf]="[item]" [ngForTemplate]="tbody" let-item ngFor></ng-template>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!iterateTableRows">
                  <ng-template [ngTemplateOutlet]="tbody"></ng-template>
                </ng-container>
                </tbody>
              </table>
            </div>
          </ng-container>
          <sb-ghost-list [ghosts]="ghosts"></sb-ghost-list>
        </div>
        <div card-footer *ngIf="!hidePagination || footerMore">
          <div (pageChange)="pageChange($event)" (pageSizeChange)="setMaxSize($event)"
               *ngIf="paginationInitialized && !hidePagination"
               [(page)]="page"
               [boundaryLinks]="boundaryLinks" [showPageSize]="!isInModalContext"
               [collectionSize]="collectionSize" [maxSize]="maxSize" [sizes]="sizes" class="w-100"
               sb-pagination>
              <span class="d-none d-sm-inline-block" *ngIf="!isInIntegratedContext">
              {{ paginationString }}
              </span>
          </div>
          <div *ngIf="footerMore" class="ml-3">
            <ng-content select="[footer-more]">

            </ng-content>
          </div>
        </div>
      </sb-card>
    </div>
  </div>
} @else {

  <div class="row">
    <div class="col-12">
      <sb-card [classes]="isInModalContext ? 'noShadow' : ''">
        <div card-header classes="no-border d-inline-block d-sm-flex">
          <ng-template [ngTemplateOutlet]="cardHeaderTemplate"></ng-template>
        </div>
        <div card-header-more classes=" justify-content-end py-3 py-sm-0">
          <ng-template [ngTemplateOutlet]="tableHeader"></ng-template>
        </div>
        <div card-fit>
          <ng-container *ngIf="additionalInputTop">
            <ng-template [ngTemplateOutlet]="additionalInputTop"></ng-template>
          </ng-container>
          <div class="tw-overflow-x-auto">
            <table class="table table-hover tw-mb-3">
              <thead>
              <ng-template [ngTemplateOutlet]="tCardHead ? tCardHead : thead"></ng-template>
              </thead>
            </table>
          </div>
        </div>
      </sb-card>
    </div>
  </div>
  <div class="row">
    <ng-container *ngIf="singleCard">
      <div class="col-xxxl-3 col-lg-4 col-md-6 col-xs-12">
        <ng-template [ngTemplateOutlet]="singleCard"></ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="card">
      <ng-container *ngFor="let item of itemsData; let i = index">
        <div class="col-xxxl-3 col-lg-4 col-md-6 col-xs-12">
          <ng-template [ngForOf]="[item]" [ngForTemplate]="card" let-item ngFor></ng-template>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="row">
    <div class="col-12">
      <sb-card [classes]="isInModalContext ? 'noShadow' : ''">
        <div card-footer class="d-flex align-items-center" *ngIf="!hidePagination || footerMore">
          <div (pageChange)="pageChange($event)" (pageSizeChange)="setMaxSize($event)"
               *ngIf="paginationInitialized && !hidePagination"
               [(page)]="page"
               [boundaryLinks]="boundaryLinks" [showPageSize]="!isInModalContext"
               [collectionSize]="collectionSize" [maxSize]="maxSize" [sizes]="sizes" class="w-100"
               sb-pagination>
              <span class="d-none d-sm-inline-block" *ngIf="!isInIntegratedContext">
              {{ paginationString }}
              </span>
          </div>
          <div *ngIf="footerMore" class="ml-3">
            <ng-content select="[footer-more]">

            </ng-content>
          </div>
        </div>
      </sb-card>
    </div>
  </div>
}
